import React, { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CFormInput,
  CButton,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell, 
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter
} from '@coreui/react';
import { fetchAuthSession  } from 'aws-amplify/auth';
import CIcon from '@coreui/icons-react'
import {cilTrash,cilSearch,cilPen} from '@coreui/icons';
import AWS from 'aws-sdk';

function Url() {


  const DYNAMODB_TABLE_NAME = 'Gourl';
  const REGION ='us-east-1';

  const dynamodb = new AWS.DynamoDB.DocumentClient({
    region: REGION,
    credentials: new AWS.Credentials({
      accessKeyId: process.env.REACT_APP_ACCESSKEYID,
      secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY
    }),
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        await fetchAuthSession().then(data => 
        {

          setInterval(() => {
            leerProyectosPorAutor(data.tokens.accessToken.payload.sub)
            setLoading(false);
          }, 1300);
          
          setUser(data.tokens.accessToken.payload.sub);
        });

      } catch (err) {
        console.log(err);
      }

    })();	
	},[]);

  const [url, setUrl] = useState('');
  const [alias, setAlias] = useState('');
  const [user, setUser] = useState('');
  const [proyectos, setProyectos] = useState([]);

  async function leerProyectosPorAutor(autor) {
    const params = {
      TableName: DYNAMODB_TABLE_NAME,
      FilterExpression: 'Autor = :autor', // Filtrar por el atributo 'Autor'
      ExpressionAttributeValues: {
        ':autor': autor,
      },
    };
  
    try {
      const data = await dynamodb.scan(params).promise();
      if (data.Items.length > 0) {
        // Aquí actualizamos el estado con los proyectos recuperados
        setProyectos(data.Items);
      } else {
        console.log('Usuario no encontrado.');
      } 
    } catch (err) {
      console.error('Error al buscar por autor:', err);
    }
  }
  
  

  const handleShorten = () => {
    if (url) {

      let overlay = document.createElement('div');
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
      overlay.style.display = 'flex';
      overlay.style.flexDirection = 'column';
      overlay.style.justifyContent = 'center';
      overlay.style.alignItems = 'center';
      overlay.style.zIndex = '9999';
      const spinner = document.createElement('div'); 
      spinner.className = 'spinner-border text-primary';
      spinner.setAttribute('role', 'status');
      const srOnly = document.createElement('span');
      srOnly.className = 'visually-hidden';
      srOnly.textContent = '';
      const downloadingText = document.createElement('p');
      downloadingText.textContent = 'Generando...';
      downloadingText.style.marginTop = '10px';
      spinner.appendChild(srOnly);
      overlay.appendChild(spinner);
      overlay.appendChild(downloadingText);
      document.body.appendChild(overlay);

      let name = alias.length ? alias : "";
  
      const jsonData = {
        "longUrl": url,
        "name": name,
        "sub": user
      };
  
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(jsonData)
      };
  
      fetch("https://go.codeflex.com.co/consultarurl", options)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          // Suponiendo que data ya es un objeto JavaScript
          const responseBody = JSON.parse(data.body);
          const shortUrl = responseBody.shortUrl;
  
          if (shortUrl === "URL-EN-USO") {
            document.body.removeChild(overlay);
            alert("/Alias en uso")
          } else {

            const isIframe = window.self !== window.top;
            const newUrl = `https://cflex.link/${shortUrl}`;

            if (isIframe) {
              alert("Por favor, subraya y copia la URL: " + newUrl);
              setUrl("")
              setAlias("")
              //window.location.reload();
            }else{
              document.body.removeChild(overlay);
              navigator.clipboard.writeText(newUrl).then(() => {
                alert("URL Copiada: " + newUrl)
                setUrl("")
                setAlias("")
                //window.location.reload();
              }).catch((error) => {
                alert("ERROR")
                console.error("Error al copiar la URL cortada: ", error);
              });
            }

          }
        })
        .catch(error => {
          document.body.removeChild(overlay);
          alert("ERROR")
          window.location.reload();
          console.log(error)
        });
    } else {
      alert("Falta URL")
    }
  };
  
  function getFaviconUrl(url) {
    if (url.includes('www.codeflex.lat/documentos/')) {
      return 'https://www.google.com/s2/favicons?domain=https://codeflex.com.co/';
    } else {
      return `https://www.google.com/s2/favicons?domain=${url}`;
    }
  }
  

  const eliminarUrl = async () => {
    let Urlcortaa = originalcorta
    let longUrl = originallarga

    const params = {
      TableName: DYNAMODB_TABLE_NAME,
      Key: {
        Urlcorta: Urlcortaa,
      },
      // Opcional: Si necesitas asegurarte que el longUrl coincide antes de eliminar
      ConditionExpression: "longUrl = :longUrlVal",
      ExpressionAttributeValues: {
        ":longUrlVal": longUrl,
      },
    };

    try {
      await dynamodb.delete(params).promise();
      console.log("Registro eliminado con éxito");
      alert("Registro eliminado con éxito.")
      setVisible3(false)
      window.location.reload();
    } catch (error) {
      console.error("Error al eliminar el registro:", error);
    }
  };

  const [visible5, setVisible5] = useState(false)
  const [visible4, setVisible4] = useState(false)
  const [visible3, setVisible3] = useState(false)
  const [urlcor, seturlcor] = useState("")
  const [urllar, seturllar] = useState("")
  const [originalcorta, setOriginalcorta] = useState("")
  const [originallarga, setOriginallarga] = useState("")

  const modalrebautizar = async (corta,larga) => { 
    seturllar(larga)
    setOriginalcorta(corta)
    setOriginallarga(larga)
    setVisible4(true)
  } 

  const modaleliminar = async (corta,larga) => { 
    setOriginalcorta(corta)
    setOriginallarga(larga)
    setVisible3(true)
  } 
  
  const modaleditar = async (corta,larga) => { 
    seturlcor(corta)
    setOriginalcorta(corta)
    setOriginallarga(larga)
    setVisible5(true)
  } 

  const actualizarUrlCorta = async () => {
    // Paso 0: Verificar si ya existe un registro con la misma Urlcorta.
    const searchParams = {
      TableName: DYNAMODB_TABLE_NAME,
      Key: {
        Urlcorta: urlcor,
      },
    };
  
    try {
      const existingItem = await dynamodb.get(searchParams).promise();
      if (existingItem.Item) {
        // Si ya existe un registro, muestra una alerta y termina la ejecución.
        alert("Alias en uso.");
        return; // Termina la ejecución de la función aquí.
      }
  
      // Paso 1: Insertar el nuevo registro con la nueva Urlcorta y los mismos datos.
      const insertParams = {
        TableName: DYNAMODB_TABLE_NAME,
        Item: {
          Urlcorta: urlcor, 
          longUrl: originallarga, 
          Autor: user
        },
      };
  
      await dynamodb.put(insertParams).promise();
      console.log("Nuevo registro creado con éxito.");
  
      // Opcionalmente, elimina el registro antiguo si el nuevo se creó con éxito.
      if (originalcorta !== urlcor) { // Verifica si la Urlcorta ha cambiado antes de eliminar.
        const deleteParams = {
          TableName: DYNAMODB_TABLE_NAME,
          Key: {
            Urlcorta: originalcorta,
          },
        };
        await dynamodb.delete(deleteParams).promise();
        console.log("Registro antiguo eliminado con éxito.");
      }
  
      alert("Nuevo Alias creado con éxito.")
      setVisible5(false)
      //window.location.reload();
  
    } catch (error) {
      console.error("Error al actualizar la Urlcorta:", error);
    }
  };
  


  const actualizarUrlLarga = async () => {
    const params = {
      TableName: DYNAMODB_TABLE_NAME,
      Key: {
        Urlcorta: originalcorta,
      },
      UpdateExpression: "set longUrl = :newLongUrl",
      ExpressionAttributeValues: {
        ":newLongUrl": urllar,
      },
      ReturnValues: "UPDATED_NEW",
    };

    try {
      const response = await dynamodb.update(params).promise();
      console.log("URL actualizada con éxito:", response);
      alert("URL actualizada con éxito.")
      setVisible4(false)
      //window.location.reload();
    } catch (error) {
      console.error("Error al actualizar URL:", error);
    }
  };
  
  const [Input, setInput] = useState("")

  function truncateUrl(url, startLength = 18, endLength = 17) {
    // Verificar si la URL necesita ser acortada
    if (url.length <= startLength + endLength) {
      return url;
    }

    // Extraer el inicio y el final de la URL
    const start = url.substring(0, startLength);
    const end = url.substring(url.length - endLength);
 
    // Devolver la URL acortada
    return `${start}......${end}`;
  }



  const copiarAlPortapapeles = (texto) => {
    navigator.clipboard.writeText(texto).then(() => {
      // Opcional: Mostrar algún mensaje de confirmación al usuario
      alert('URL copiada al portapapeles');
    }).catch(err => {
      // Manejar posibles errores
      console.error('Error al copiar texto al portapapeles', err);
    });
  }
  
  const [searchInput, setSearchInput] = useState("");
  

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={4}>

      <CModal
      style={{
        position: 'fixed',
        width: '100%',
        height: '100%',
        background: 'rgba(255, 255, 255, 1)',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 9999,
      }}
     visible={visible3} onClose={() => setVisible3(false) + setInput("")} >
      <CModalHeader>
        <CModalTitle>¿Eliminar objeto permanentemente?</CModalTitle>
      </CModalHeader>
      <CModalBody style={{fontSize:"17px"}}>Para confirmar la eliminación, escriba eliminar de forma permanente en el campo de entrada de texto.<br/></CModalBody>
      <CModalFooter >
        <CFormInput type="text" size="sm" placeholder="eliminar de forma permanente" onChange={e => setInput(e.target.value)} aria-label="sm input example"/>
        <CButton color="light" onClick={() => setVisible3(false) + setInput("")}>Cerrar</CButton>
        {Input == "eliminar de forma permanente" ?
        <CButton color='warning'  onClick={eliminarUrl} >Eliminar</CButton>
        :
        <CButton disabled color='warning'>Eliminar</CButton>
        }
      </CModalFooter>
      </CModal>


      <CModal 
        style={{
          position: 'fixed',
          width: '100%',
          height: '100%',
          background: 'rgba(255, 255, 255, 1)',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 9999,
        }}
        visible={visible5} onClose={() => setVisible5(false)}>
              <CModalHeader >
                <CModalTitle>URL Corta</CModalTitle>
              </CModalHeader>
              <CModalBody>
              <CFormInput size="sm" type="text" id="input" placeholder='Ingresa el nombre'  value={urlcor} onChange={c => seturlcor(c.target.value)}/>
              <span style={{fontSize:"17px"}}>Ingresa el nuevo alias: https://cflex.link/{urlcor}<br/></span>
                <center>
                  <CButton color="info" shape="rounded-pill"  size="sm" onClick={actualizarUrlCorta}>
                    Editar
                  </CButton>
                </center>
              </CModalBody>
        </CModal>

        <CModal 
        style={{
          position: 'fixed',
          width: '100%',
          height: '100%',
          background: 'rgba(255, 255, 255, 1)',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 9999,
        }}
        visible={visible4} onClose={() => setVisible4(false)}>
              <CModalHeader >
                <CModalTitle>URL Larga</CModalTitle>
              </CModalHeader>
              <CModalBody>
              <CFormInput size="sm" type="text" id="input" placeholder='Ingresa URL'  value={urllar} onChange={c => seturllar(c.target.value)}/>
              <span style={{fontSize:"17px"}}>Por favor, ingresa la nueva URL a buscar en el campo.<br/></span>
                <center>
                  <CButton color="info" shape="rounded-pill"  size="sm" onClick={actualizarUrlLarga}>
                    Rebautizar
                  </CButton>
                </center>
              </CModalBody>
        </CModal>
   
        <CCol xs={12}>
          <CCard className="mb-4 ccard-custom-style" style={{ borderRadius: '6px' }}>
            <CCardHeader>
              <strong>Acortador de URL</strong> <small>/Admin</small>
            </CCardHeader>
            <CCardBody>
              <CCard>
                <CCardBody style={{ borderRadius: '6px', marginTop: '1rem', textAlign: 'center' }}>
  
                  <CRow>
                    <CCol xs={12}>
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.5rem' }}>
                        <CFormInput
                          placeholder="Escribe tu URL aquí"
                          value={url}
                          onChange={(e) => setUrl(e.target.value)}
                        />
                        <span>/</span>
                        <CFormInput
                          placeholder="Alias (opcional)"
                          value={alias}
                          onChange={(e) => setAlias(e.target.value)}
                        />
                      </div>
                    </CCol>
                    <CCol xs={12} style={{ marginTop: '1rem' }}>
                      <CButton color="dark" onClick={handleShorten}>
                        Acortar
                      </CButton>
                    </CCol>
                  </CRow> 

                </CCardBody>
              </CCard>
            </CCardBody>
          </CCard>
        </CCol><br/>


        <CCol xs={12}>
          <CCard className="mb-4 ccard-custom-style" style={{ borderRadius: '6px' }}>
            <CCardHeader>
              <strong>URLs ({proyectos.length})</strong>
            </CCardHeader>

          {proyectos.length ? 
           <>
           <CCardBody>

           <div className="d-flex align-items-center">
               <CFormInput
                 type="text"
                 size="sm"
                 placeholder="Search URL larga"
                 aria-label="sm input example"
                 value={searchInput} 
                 onChange={(e) => setSearchInput(e.target.value)}
               />
           </div><br/>

           <div className="table-responsive-wrapper" style={{ overflowX: 'auto', paddingBottom: '1rem' }}>
             <CTable responsive bordered id="proyectos-table" small className="elegant-table">
             <CTableHead>
               <CTableRow>
                 <CTableHeaderCell scope="col">Img</CTableHeaderCell>
                 <CTableHeaderCell scope="col">URL larga</CTableHeaderCell>
                 <CTableHeaderCell scope="col">URL Corta</CTableHeaderCell>
                 <CTableHeaderCell scope="col">AC</CTableHeaderCell>
                 <CTableHeaderCell scope="col">Clics</CTableHeaderCell>
                 <CTableHeaderCell scope="col">Rebautizar</CTableHeaderCell>
                 <CTableHeaderCell scope="col">Editar</CTableHeaderCell>
                 <CTableHeaderCell scope="col">Eliminar</CTableHeaderCell>
               </CTableRow>
             </CTableHead>
             <CTableBody>
               {proyectos.map((proyecto, index) => 
                 (searchInput === "" || proyecto.longUrl.toLowerCase().includes(searchInput.toLowerCase())) &&( 
                 <CTableRow key={index} className="row-hover">
                   <CTableDataCell className="td2"><center><img src={getFaviconUrl(proyecto.longUrl)} alt="Favicon" style={{ width: '24px', height: '24px' }} /></center></CTableDataCell>
                   <CTableDataCell className="td2">{truncateUrl(proyecto.longUrl)}</CTableDataCell>
                   <CTableDataCell className="td2">https://cflex.link/{proyecto.Urlcorta}                 
                   </CTableDataCell>

                   <CTableDataCell className="td2">    
                   <center>          
                   <a href={`https://cflex.link/${proyecto.Urlcorta}`} target="_blank" rel="noopener noreferrer">
                     <i className="fas fa-external-link-alt" style={{ marginLeft: "10px" }}></i>
                   </a>&nbsp;&nbsp;&nbsp;&nbsp;

                   <a href="#" onClick={(e) => {
                       e.preventDefault(); // Prevenir la acción por defecto del enlace
                       copiarAlPortapapeles(`https://cflex.link/${proyecto.Urlcorta}`);
                     }}>
                     <i className="fas fa-copy" style={{ marginLeft: "10px" }}></i>
                   </a>
                   </center>
                   </CTableDataCell>

                   <CTableDataCell className="td2"><center style={{fontSize:"15.4px"}}>{proyecto.click}</center></CTableDataCell>

                   <CTableDataCell className="td2"> 
                     <center>
                       <CButton component="a" color="info"  role="button" onClick={() => modalrebautizar(proyecto.Urlcorta, proyecto.longUrl)}>
                         <CIcon icon={cilSearch} size="lg" style={{ marginRight: '3px' }} /> 
                       </CButton>
                     </center> 
                   </CTableDataCell>
                   <CTableDataCell className="td2"> 
                     <center>
                       <CButton component="a" color="success"  role="button" onClick={() => modaleditar(proyecto.Urlcorta, proyecto.longUrl)}>
                         <CIcon icon={cilPen} size="lg" style={{ marginRight: '3px' }} /> 
                       </CButton>
                     </center> 
                   </CTableDataCell>
                   <CTableDataCell className="td2"> 
                     <center>
                       <CButton component="a" color="danger"  role="button"  onClick={() => modaleliminar(proyecto.Urlcorta, proyecto.longUrl)}>
                         <CIcon icon={cilTrash} size="lg" style={{ marginRight: '3px' }} /> 
                       </CButton>
                     </center> 
                   </CTableDataCell>
                 </CTableRow>
               ))}
             </CTableBody>
           </CTable>
           </div>
           </CCardBody>
           </>
            :  
            <center><div style={{fontSize:"20px", backgroundColor:"#f1f4f4"}}>Esperando URLs...</div></center>
          } 
          </CCard>
        </CCol>
      </SoftBox>
      <Footer />
    </DashboardLayout>

  );
}

export default Url;
